module.exports = __webpack_public_path__ + "img/404.d61d53a5.png";